import { render, staticRenderFns } from "./SetupWizard.vue?vue&type=template&id=78166d2d&scoped=true"
import script from "./SetupWizard.vue?vue&type=script&lang=js"
export * from "./SetupWizard.vue?vue&type=script&lang=js"
import style0 from "./SetupWizard.vue?vue&type=style&index=0&id=78166d2d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78166d2d",
  null
  
)

export default component.exports